<template>
    <div style="margin-bottom: 150px;">
        <div v-if="gameBannerStatus">
            <div class="menu-item menu-fold1" 
                    style="padding-top: 10px; padding-bottom: 10px;" 
                    :class="[( isGameBannerSelected? 'active' : '')] " 
                    @click.prevent="selectGameBanner()">
                <div class="vrow items-center"><gameBanner :position="'mini'"></gameBanner></div>
                <div class="items-right vrow" style="flex-wrap: wrap;">
                    <div style="line-height: 1; flex: 1 1 0%;">
                        <span v-html="gameBannerImage.bannerName_cn" class="menu-text" v-if="selectedLang == 'zh_CN'"></span>
                        <span v-html="gameBannerImage.bannerName_tw" class="menu-text" v-else-if="selectedLang == 'zh_TW'"></span>
                        <span v-html="gameBannerImage.bannerName_en" class="menu-text" v-else></span>
                    </div>
                    <div class="col-right" style="min-width: 40px;">        
                        <!-- <div v-if="comp_live(sport.sprtId)" class="live-text" ></div> -->
                        <span class="match-count yb-family-odds amount">{{ gameBannerCountMatch(selectedMarket) }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="specialEventStatus">
            <div class="menu-item menu-fold1" style="padding-top: 10px; padding-bottom: 10px;" :class="[( specialEvent && !liveSchedule? 'active' : '')]" @click.prevent="changeSport(specialEventList['sprtId'])">
                <div class="vrow items-center"><span class="q-icon icon c-icon sport-img icon img36 SP"></span></div>
                <div class="items-right vrow" style="flex-wrap: wrap;">
                    <div style="line-height: 1; flex: 1 1 0%;">
                        <span class="menu-text">{{ lang.sportTableLang['SPORT_TABLE.SPECIAL_EVENT'] }}</span>
                    </div>
                    <div class="col-right" style="min-width: 40px;">        
                        <!-- <div v-if="comp_live(sport.sprtId)" class="live-text" ></div> -->
                        <span class="match-count yb-family-odds amount"></span>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div>
            <div class="menu-item menu-fold1" 
                    style="padding-top: 10px; padding-bottom: 10px;" 
                    :class="[( simpleSport == sportList[0].sprtId && selectedMarket != market.inPlayMarket.key? 'active' : '')] " 
                    @click.prevent="changeSport(sportList[0],true)">
                <div class="vrow items-center"><span class="q-icon icon c-icon sport-img icon" :class="'icon_simple_'+sportList[0].sprtId"></span></div>
                <div class="items-right vrow" style="flex-wrap: wrap;">
                    <div style="line-height: 1; flex: 1 1 0%;"> -->
                        <!-- <span v-html="" class="menu-text"></span> -->
                        <!-- <span class="menu-text">{{ lang.sportTableLang['SPORT_TABLE.SIMPLE_SOCCER'] }}</span>
                    </div>
                    <div class="col-right" style="min-width: 40px;">        
                        <div v-if="comp_live(sportList[0].sprtId)" class="live-text" ></div>
                        <span class="match-count yb-family-odds amount">{{ countMatch(sportList[0].sprtId, selectedMarket) }}</span>
                    </div>
                </div>
            </div>
        </div> -->
        <template v-for="sport in sportList">
            <div v-if="sport.sprtId == 'N1'">
                <div class="menu-item menu-fold1" 
                        style="padding-top: 10px; padding-bottom: 10px;" 
                        :class="[( simpleSport == sport.sprtId && selectedMarket != market.inPlayMarket.key? 'active' : '')] " 
                        @click.prevent="changeSport(sport,true)" :style="(sport_feature && countMatch('N1', selectedMarket)==0 && sportList[0]['sprtId']!='N1') ? 'display: none' : ''">
                    <div class="vrow items-center"><span class="q-icon icon c-icon sport-img icon" :class="'icon_simple_'+sport.sprtId"></span></div>
                    <div class="items-right vrow" style="flex-wrap: wrap;">
                        <div style="line-height: 1; flex: 1 1 0%;">
                            <!-- <span v-html="" class="menu-text"></span> -->
                            <span class="menu-text">{{ lang.sportTableLang['SPORT_TABLE.SIMPLE_SOCCER'] }}</span>
                        </div>
                        <div class="col-right" style="min-width: 40px;">        
                            <div v-if="comp_live(sport.sprtId)" class="live-text" ></div>
                            <span class="match-count yb-family-odds amount">{{ countMatch(sport.sprtId, selectedMarket) }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="menu-item menu-fold1" 
                        style="padding-top: 10px; padding-bottom: 10px;" 
                        :class="[(selectedSport.sprtId==sport.sprtId && selectedMarket != market.inPlayMarket.key && selectedMarket != market.hotSportMarket.key  && selectedBettype.tmpltId!=11 && !isGameBannerSelected && simpleSport == null && !liveSchedule ? 'active' : '')] " 
                        @click.prevent="changeSport(sport, false)" :style="countMatch(sport.sprtId, selectedMarket)==0 && sport.sprtId!=((sport_feature) ? sportList[0]['sprtId'] : 'N1') ? 'display: none   ':''">
                    <div class="vrow items-center"><span class="q-icon icon c-icon sport-img icon img36" :class=" sport.sprtId "></span></div>
                    <div class="items-right vrow" style="flex-wrap: wrap;">
                        <div style="line-height: 1; flex: 1 1 0%;">
                            <span v-html="sport.sprtLang" class="menu-text"></span>
                        </div>
                        <div class="col-right" style="min-width: 40px;">        
                            <div v-if="comp_live(sport.sprtId)" class="live-text" ></div>
                            <span class="match-count yb-family-odds amount">{{ countMatch(sport.sprtId, selectedMarket) }}</span>
                        </div>
                    </div>
                </div>
                <div data-v-20a71bf8="" class="menu-fold2-wrap open" 
                    v-if="selectedSport.sprtId == sport.sprtId && selectedMarket != market.inPlayMarket.key && selectedMarket != market.hotSportMarket.key && showOdds && selectedBettype.tmpltId!=11"> 
                    <template  v-for="(bettype,key) in bettypeList" >
                        <div class="menu-item menu-fold2" :class="sportItem(bettype.betTypId)" @click.prevent="changeBettype(bettype)" >
                            <div class="row items-center relative-position">
                                <span class="menu-point"></span>
                                <span class="betTypeName" v-if="selectedSport.sprtId=='G1' && bettype.betTypId=='7'" :title="lang.sportAllBet['ALL_BET.LBL_BETTYPE_BASKETBALL']">
                                    {{ lang.sportAllBet['ALL_BET.LBL_BETTYPE_BASKETBALL'] }}
                                </span>
                                <span class="betTypeName menu-text ellipsis" :title="bettype.betTypLang">{{ bettype.betTypLang }}</span>
                            </div>
                            <div data-v-20a71bf8="" class="col-right relative-position">
                                <span data-v-20a71bf8="" class="match-count yb-family-odds">{{ sportCount(sport.sprtId, bettype.betTypId, selectedMarket) }}</span>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </template>
        <template v-if="showOutright">
            <div v-if="otrBetType!=undefined" class="menu-item menu-top menu-virtual menu-border" 
                @click.prevent="changeBettype(otrBetType,11)" :class="[(selectedBettype.tmpltId==11 ? 'active' : '')]">
                <span data-v-0d68232c="" class="q-icon icon c-icon sport-img img36" style="width: 18px; height: 18px; background-position: 0px -943.5px;"></span>
                <div class="menu-name col">{{ lang.configLang['CONFIG_LANG.LBL_GAME_OUTRIGHT'] }}</div>
                <div class="col-right">
                    <span class="match-count yb-family-odds">{{ countOTR() }}</span>
                </div>
            </div>
        </template>
    </div>
</template>

<script>

// import VueGlobalClickEvent from '@/vue/directives/globalClickEvent'
import sportMatchCount from '@/vue/mixins/sportMatchCount'
import vueCookie from 'vue-cookie'
import EventBus from '../../../events/event-bus'
import gameBanner from './gameBanner'

import {
    mapGetters
} from 'vuex'

export default {
    mixins: [ sportMatchCount ],
    components: { 
        gameBanner,
     },
    computed: {
        ...mapGetters([
            'selectedBettype',
            'selectedSport',
            'sportList',
            'market',
            'selectedMarket',
            'allSportCount',
            'open_RBMarket',
            'otrBetType',
            'isParlayTab',
            'previousBettype',
            'isGameBannerSelected',
            'gameBannerSportCount',
            'gameBannerSportId',
            'simpleSport',
            'liveSchedule',
            'bettypeFeature',
	    'specialEvent',
            'specialEventList',
        ]),
    
        bettypeList() {
            var availableBettypeList = this.$store.getters.bettypeList
            //var filter
            if(this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key){
                availableBettypeList = _.remove(availableBettypeList, function(bettype) {
                    return bettype.betTypId != '5' || bettype.betTypId != '6'
                })
            }

            if (this.bettypeFeature) {
                var btlist = {};
                var VUE = this;

                availableBettypeList = availableBettypeList.filter(bettype => {
                    if (this.bettypeFeature.includes('15') && bettype.betTypId === '5') return false; //parlay
                    if (this.bettypeFeature.includes('14') && bettype.betTypId === '6') return false; //outright
                    if (this.$store.getters.selectedMarket == this.$store.getters.market.earlyMarket.key || this.$store.getters.selectedMarket == this.$store.getters.market.tdyMarket.key) {
                        if (this.bettypeFeature.includes('7') && bettype.betTypId == '2') return false; //correct score
                        if (this.bettypeFeature.includes('5') && bettype.betTypId == '3') return false; //total goal
                        if (this.bettypeFeature.includes('6') && bettype.betTypId == '4') return false; //htft
                    } else if (this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key) {
                        if (this.bettypeFeature.includes('16') && bettype.betTypId == '2') return false; //correct score
                        if (this.bettypeFeature.includes('18') && bettype.betTypId == '3') return false; //total goal
                        if (this.bettypeFeature.includes('17') && bettype.betTypId == '4') return false; //htft
                    }

                    return true;
                });
            }
            return availableBettypeList
        },

        showOutright() {
            if (this.bettypeFeature && this.bettypeFeature.includes('14')) {
                return false;
            }
            return true;
        }
    },
    data() {
        return {
            sportBettypeList: window.sportBettypeList,
            lang: window.lang,
            selectedLang: vueCookie.get(window.compcode+ '_lang'),
            allDate: '99',
            todayDate: '0',
            showOdds: true,
            // otrBt:{
            //     betTypId:"6",
            //     betTypLang:"Outrights",
            //     sprtId:"G98",
            //     // sprtLang:"Soccer",
            //     // sprtTitleLang:"Soccer",
            //     tmpltId:"11",
            // },
            rbAllSport: {
                "sprtId": "G98",
            },
            gameBannerStatus: window._gameBanner,
            gameBannerImage: window._gameBannerImage,
	    sport_feature: window.sport_feature,
            specialEventStatus: window.specialEventStatus,
            spEventList: window.specialEventList,
        }
    },
    methods : {
        checkHeartbeat() {
            return true
        },
        changeSport(sport, simpleSport=false) {
            if(this.$store.getters.selectedSport.sprtId != 'G98' && this.$store.getters.selectedSport != sport && this.$store.getters.isBetParlay){
                this.$store.commit("IS_BETPARLAY", false);
                this.$store.commit("REMOVE_MATCH", { removeAll: true });
                this.$store.commit("SHOW_BETFORM_MENU", false);
            }
            if(this.$store.getters.selectedMarket == 2){
                this.$store.dispatch('getEarlyEventCountByDate');
            }
            if(simpleSport){
                this.$store.commit('SIMPLE_SPORT', sport.sprtId)
            } else {
                this.$store.commit('SIMPLE_SPORT', null)
            }
            this.$store.commit("IS_PARLAY_TAB", false);
            this.$store.commit("SPECIAL_EVENT", (sport == this.specialEventList['sprtId'])? true:false);
            if(simpleSport || this.$store.getters.specialEvent) {
                this.showOdds = false;
            }else if(this.$store.getters.selectedSport == sport && this.$store.getters.selectedBettype.tmpltId!=11 ){
                this.showOdds = !this.showOdds;
            }else{
                this.showOdds = true;
            }
            EventBus.$emit('refreshOdd', true);
            this.$store.commit("GAMEBANNER_SELECTED", false);
            this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
            this.$store.commit('SELECTED_ALLBET', false)
            this.$store.commit('SELECTED_MATCHALLBET', false)
            this.$store.commit('SPORT_SHOW_FAV_EVENTS', false)
            this.$store.commit('OPEN_RBMARKET', false)
            this.$store.commit('SORTEDRBEVENTLIST', [])
            this.$store.commit('SORTEDEVENTLIST', [])
            this.$store.commit('EVENTLIST', [])
            this.$store.commit('FAVOURITERBEVENTCOUNT', 0)
            this.$store.commit('FAVOURITEEVENTCOUNT', 0)
            this.$store.commit("LIVE_SCHECULE", false)
            
            EventBus.$emit('viewAccountSetting', false)
            this.$store.commit('SELECTED_SPORT', sport)
            if(this.$store.getters.selectedMarket == 3 || this.$store.getters.hotSchedule){
                this.$store.commit('SELECTED_MARKET', 1)
            }
            this.$store.commit("HOT_SCHEDULE", false)
            this.commitBettypeList()
            this.$store.commit('SELECTED_BETTYPE',  _.cloneDeep(this.$store.getters.bettypeList[0]))
            var setBt =this.$store.getters.selectedBettype;
            if(this.$store.getters.selectedBettype.tmpltId==11){
                setBt.tmpltId=1;
            }
            if(!this.$store.getters.specialEvent){   
                EventBus.$emit('sportChange', setBt );
		if(this.$store.getters.selectedMarket == 3 || this.$store.getters.hotSchedule){
                	this.$store.commit('SELECTED_MARKET', 1)
            	}

            } else {
                EventBus.$emit('getSpecialEvent');
            }
            var sideBarMini = $('.sidebar-first').hasClass('mini')
        },
        comp_live(sport){
            var Vue = this
            if(!_.isUndefined(Vue.allSportCount.live) && Vue.allSportCount.live[sport]!== undefined){
                if(Object.keys(Vue.allSportCount.live[sport]).length > 0){
                    return true; 
                }else{
                    return false;
                }
            }
        },
        changeBettype(bettype,otr) {
            EventBus.$emit('refreshOdd', true);
            this.$store.commit("IS_PARLAY_TAB", false);
            this.$store.commit('SIMPLE_SPORT', null)
            this.$store.commit("SPECIAL_EVENT", false);
            if(otr==11){
                bettype.tmpltId=11
                this.$store.commit('SELECTED_SPORT', this.rbAllSport)
                EventBus.$emit('refreshOdd', true);
                this.commitBettypeList()
                this.$store.commit('OPEN_RBMARKET', false)
                EventBus.$emit('marketChange', this.$store.getters.selectedMarket==3?'1':this.$store.getters.selectedMarket );
                this.$store.commit('SELECTED_MARKET', this.$store.getters.selectedMarket==3?'1':this.$store.getters.selectedMarket)
            }
            if(bettype.betTypId=='5'){ //mulp clear betcombo setting
                this.$store.commit("IS_PARLAY_TAB", true);
                this.$store.commit("IS_BETCOMBO", false);
                this.$store.commit("SPORT_MINIBET_TOGGLE", false);
                this.$store.dispatch('getEarlyEventCountByDate');              
                if(!this.$store.getters.isBetParlay && this.$store.getters.betForm.length>0){
                    this.$store.commit("REMOVE_MATCH", { removeAll: true });
                    this.$store.commit("SHOW_BETFORM_MENU", false);
                }
                
            }
            if(bettype.betTypId=='6'){
                if((this.$store.getters.isBetParlay || this.$store.getters.selectedBettype.betTypId=='5')){
                    this.$store.commit("IS_BETPARLAY", false);
                    if(this.$store.getters.betForm.length>0){
                        this.$store.commit("REMOVE_MATCH", { removeAll: true });
                    }
                    this.$store.commit("SHOW_BETFORM_MENU", false);
                }
            }

            this.$store.commit("GAMEBANNER_SELECTED", false);
            this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
            this.$store.commit('SELECTED_ALLBET', false)
            this.$store.commit('SELECTED_MATCHALLBET', false)
            this.$store.commit('SPORT_SHOW_FAV_EVENTS', false)
            this.$store.commit('SORTEDRBEVENTLIST', [])
            this.$store.commit('SORTEDEVENTLIST', [])
            this.$store.commit('RBEVENTLIST', [])
            this.$store.commit('EVENTLIST', [])
            this.$store.commit('MERGE_LEAGUELIST', null)
            this.$store.commit("LIVE_SCHECULE", false)
            this.$store.commit("HOT_SCHEDULE", false)

            if(this.$store.getters.selectedMarket=='1'){
                this.$store.commit('SELECTEDEARLYPARLAYDATE', this.todayDate)
            } else {
                this.$store.commit('SELECTEDEARLYPARLAYDATE', this.allDate)
            }
            // this.$store.commit('SELECTED_LEAGUELIST', [])
            
            EventBus.$emit('viewAccountSetting', false)
            if(bettype){
                //get latest-info used purpose
                if(bettype.betTypId == '5' && this.$store.getters.sportPrevIsMulp) {
                this.$store.commit('SPORT_PREVIOUS_IS_MULP', true)
                } else {
                this.$store.commit('PARLAY_SELECTED', {update : false})
                this.$store.commit('SPORT_PREVIOUS_IS_MULP', false)
                }
                this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(bettype))
            } else {
                var temp = this.$store.getters.selectedBettype
                temp.betTypId = null
                temp.tmpltId = null
                this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(temp))
            }
            EventBus.$emit('sportChange', this.$store.getters.selectedBettype );
        },
        sportIcon(sportID){

            return this.selectedSport.sprtId == sportID ? 'icon-sport'+sportID+' active' : 'icon-sport'+sportID
        },
        sportItem(betTypId) {
            var ret = ''
            if(this.selectedBettype.betTypId == betTypId){
                ret = 'active'
                if(this.selectedBettype.betTypId == '5' && !this.isParlayTab){
                    ret = ''
                }
            }
            if(this.selectedBettype.betTypId == '5' && !this.isParlayTab && this.previousBettype && this.previousBettype.bettype && betTypId == this.previousBettype.bettype.betTypId){
                ret = 'active'
            }
            return ret
        },
        commitBettypeList() {
            if(this.$store.getters.selectedSport.sprtId == 'G98' || this.$store.getters.specialEvent){
                this.$store.commit('BETTYPELIST',
                    _.filter(
                        this.sportBettypeList,
                        {
                            'sprtId' : (this.sport_feature) ? this.sportList[0]['sprtId'] : 'N1'
                        }
                    )
                )
            }else{
                this.$store.commit('BETTYPELIST',
                    _.filter(
                        this.sportBettypeList,
                        {
                            'sprtId' : this.$store.getters.selectedSport.sprtId
                        }
                    )
                )
            }
        },
        countMatch(sprtId, market) {
            
            var Vue = this
            var count = []
            var markerKey=[]
            markerKey[1]='today';
            markerKey[2]='early';
            markerKey[3]='live';

            if(this.$store.getters.hotSchedule && market == 5) {
                market = this.$store.getters.prevMarket;
            }
           
            if(markerKey[market] != undefined && Vue.allSportCount[markerKey[market]] != undefined){
                if(Vue.allSportCount[markerKey[market]][sprtId] != undefined){
                    $.each(Vue.allSportCount[markerKey[market]][sprtId], function(key, val){
                        if(key == 'AH' ){
                            count.push(val)
                        }else if(key == 'RAH' && market!=2){
                            count.push(val)
                        }else if(key == 'OTR'){
                            count.push(val)
                        //    count = _.clone(tdyElyOTR)
                        }
                    })
                }
            }
            if(market==1){
                if(Vue.allSportCount[markerKey[2]] != undefined && Vue.allSportCount[markerKey[2]][sprtId] != undefined){
                    $.each(Vue.allSportCount[markerKey[2]][sprtId], function(key, val){
                        if(key == 'OTR'){
                            count.push(val)
                        //    count = _.clone(tdyElyOTR)
                        }
                    })
                }
            }
            return _.sum(count) 
        },
        sportCount(sprtId, betTypId, market) {
            var amount = 0
            var Vue = this
            var markerKey=[]
            markerKey[1]='today';
            markerKey[2]='early';
            markerKey[3]='live';
            if(markerKey[market] != undefined && Vue.allSportCount[markerKey[market]] != undefined){
                if(Vue.allSportCount[markerKey[market]][sprtId] != undefined){
                    $.each(Vue.allSportCount[markerKey[market]][sprtId], function(key, val){
                        if(key == 'AH' && (betTypId == '1' || betTypId == '7' || betTypId == '9' ||  betTypId == '10' )){
                            amount +=val
                        }else if(key == 'RAH' && (((betTypId == '1' || betTypId == '7' || betTypId == '9' ||  betTypId == '10' ) && market!=3) || betTypId == '8')){
                            amount +=val
                        }else if(key == 'CS' && betTypId == '2'){
                            amount +=val
                        }else if(key == 'RCS' && betTypId == '2' && market!=3){
                            amount +=val
                        }else if(key == 'TG' && betTypId == '3'){
                            amount +=val
                        }else if(key == 'RTG' && betTypId == '3' && market!=3){
                            amount +=val
                        }else if(key == 'HT' && betTypId == '4'){
                            amount +=val
                        }else if(key == 'RHT' && betTypId == '4' && market!=3){
                            amount +=val
                        }else if(key == 'MULP' && betTypId == '5'){
                            amount +=val
                        }else if(key == 'OTR'  && betTypId == '6'){
                            amount +=val
                        }
                    })
                }
                if(market==1 && betTypId == '6'){
                    if(Vue.allSportCount[markerKey[2]]!=undefined && Vue.allSportCount[markerKey[2]][sprtId] != undefined){
                        $.each(Vue.allSportCount[markerKey[2]][sprtId], function(key, val){
                            if(key == 'OTR'   && betTypId == '6'){
                                amount +=val
                            }
                        })
                    }
                }
            }
            if(market==1 && Vue.allSportCount[markerKey[3]]!=undefined){
                if(Vue.allSportCount[markerKey[3]][sprtId] != undefined){
                    $.each(Vue.allSportCount[markerKey[3]][sprtId], function(key, val){
                         if(key == 'RCS' && betTypId == '2' && market!=3){
                            amount +=val
                        }else if(key == 'RTG' && betTypId == '3' && market!=3){
                            amount +=val
                        }else if(key == 'RHT' && betTypId == '4' && market!=3){
                            amount +=val
                        }
                    })
                }
            }
            return amount
            
        },
        hideContent() {
             var sportListActive = $('.category-sportList').hasClass('active')

            if(sportListActive){
                $('.widgetArea').find('.scroll-panel').css('overflow', 'hidden');
                $('.widgetArea').find('.scroll-content').css('width', '');
            }
            $('.mini').find('.category-sportList').removeClass('active')
        },
        countOTR() {
            
            var Vue = this
            var count =0;
            var sportList = Vue.allSportCount

            $.each(sportList['today'], function(sport, bettype){
                $.each(bettype, function(key, val){
                    if(key == 'OTR'  && sport.charAt(0)=='N'  ){
                        count+=val
                    }
                })
            })

            $.each(sportList['early'], function(esport, ebettype){
                $.each(ebettype, function(ekey, eVal){
                    if(ekey == 'OTR'  && esport.charAt(0)=='N' ){
                        count+=eVal
                    }
                })
            })
            
            return count
        },
        selectGameBanner() {
            this.$store.commit("LIVE_SCHECULE", false);
            this.$store.commit("HOT_SCHEDULE", false)
            EventBus.$emit('selectGameBanner');
        },
        gameBannerCountMatch(market) {
            if(this.$store.getters.hotSchedule && market == 5) {
                market = this.$store.getters.prevMarket;
            }
            if(this.gameBannerSportCount && this.gameBannerSportCount[market] && this.gameBannerSportCount[market][this.gameBannerSportId.split('N').pop()]){
                return this.gameBannerSportCount[market][this.gameBannerSportId.split('N').pop()]
            } else {
                return 0
            }
        },
        
    },
    created() {
        
    },
    mounted () {
        EventBus.$on('leftBarChangeSport', (sport)=> {
            this.changeSport(sport);
        })
        EventBus.$on('changeSimpleSport', (sport)=> {
            this.changeSport(sport, true);
        })
        EventBus.$on('changeShowOdds', (res)=> {
            this.showOdds = res
        })
    },
    destroyed() {
        EventBus.$off('leftBarChangeSport')
        EventBus.$off('changeSimpleSport')
        EventBus.$off('changeShowOdds')
    },
    beforeMount() {
        this.$store.commit('SPECIAL_EVENT_LIST', this.spEventList)
        this.$store.commit('SPORTLIST', _.uniqBy(this.sportBettypeList,'sprtId'))
        this.$store.commit('SPORTBETTYPELIST', this.sportBettypeList)
        var sport_id = 0
        if(window.sprtid != '') {
            const index = this.$store.getters.sportList.findIndex(item => item.sprtId === 'N'+window.sprtid)
            if(index !== -1){
                sport_id = index;
                if(window.selectedMrkt != '') {
                    this.$store.commit('SELECTED_MARKET', window.selectedMrkt)
                    if(window.selectedMrkt == this.$store.getters.market.earlyMarket.key) {
                        this.$store.dispatch('getEarlyEventCountByDate');
                    }
                }
            }
        }
        this.$store.commit('SELECTED_SPORT', this.$store.getters.sportList[sport_id])
        this.commitBettypeList()
        this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(this.$store.getters.bettypeList[0]))
    }
}
</script>


// WEBPACK FOOTER //
// resources/wob/vue/apps/home/contentsLeft/sportCategory.vue